import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getTranslations } from "../services/apiHelpers";
import { ensureTokenRefreshed } from "../services/axiosInstance";

export const initI18next = async (
  appNamespace: string,
  language: string,
  fetchNamespace?: string,
) => {
  await ensureTokenRefreshed();

  await i18n.use(initReactI18next).init({
    fallbackLng: language,
    lng: language,
    defaultNS: appNamespace,
    interpolation: {
      escapeValue: false,
    },
  });

  const [translations] = await Promise.all([
    getTranslations(language, fetchNamespace ? fetchNamespace : appNamespace),
  ]);

  if (translations) {
    i18n.addResourceBundle(language, appNamespace, translations, true, true);
  }
  i18n.changeLanguage(language);
};

export const loadLanguageResources = async (
  language: string,
  appNamespace: string,
  fetchNamespace?: string,
) => {
  if (!i18n.hasResourceBundle(language, appNamespace)) {
    const translations = await getTranslations(
      language,
      fetchNamespace ? fetchNamespace : appNamespace,
    );
    i18n.addResourceBundle(language, appNamespace, translations, true, true);
  }
  i18n.changeLanguage(language);
};

export default i18n;
